import { render, staticRenderFns } from "./batchImportInsurancePolicy.vue?vue&type=template&id=5fbbd3dc&scoped=true"
import script from "./batchImportInsurancePolicy.vue?vue&type=script&lang=js"
export * from "./batchImportInsurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./batchImportInsurancePolicy.vue?vue&type=style&index=0&id=5fbbd3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbbd3dc",
  null
  
)

export default component.exports